import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import {
  qalBoxSearchMediaG2,
} from '../../services/mp-cf-api-service';

const mediaSearchV2 = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setOperationData ] = useState(null);
  const {
    searchConfig,
    onOperationComplete,
  } = updateData || {};

  const searchMediaItems = async () => {
    try {
      console.log(`QalBox searching media...`);
      setResponseData({
        isLoading: true,
        isError: false,
      });

      const mediaItemsApiResp = await qalBoxSearchMediaG2({
        data: searchConfig,
      });

      const responseData = _.get(mediaItemsApiResp, 'data', {});

      let errorMsg = null;
      let isError = false;

      if(responseData.success) {
        console.log('QalBox search media items add/update Success!!');
      } else {
        console.log('QalBox search media items add/update Failed!!');
        errorMsg = `Failed to search QalBox media items.`;
        isError = true;
      }

      setResponseData({
        isLoading: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while searching QalBox media items. ', err);
      const errorMsg = `Error occurred while searching QalBox media items.`;
      setResponseData({
        isLoading: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      searchMediaItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setOperationData,
  ];
};

export default mediaSearchV2;
